module.exports = __webpack_public_path__ + "static/AvenirLTStd-Black-a686dc633baea8647fe8936d090bee79.woff";